import React, { Component } from 'react';
import classes from './MulchTypes.css';
import Input from '../../../components/UI/Input/Input';
import { connect } from 'react-redux';
import { checkValidity } from '../../../shared/utility';

class MulchTypes extends Component {
    state = {
        orderForm: {
            hardwoodBags: {
                label: '# Hardwood @ $4.50',
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: '0'
                },
                validation: {
                    required: false,
                    numeric: true,
                    minlength: 0,
                    maxLength: 4
                }
            },
            cedarBags: {
                label: '# Cedar @ $4.50',
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: '0'
                },
                validation: {
                    required: false,
                    numeric: true,
                    minlength: 0,
                    maxLength: 4
                }
            },
            blackBags: {
                label: '# Black @ $4.50',
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: '0'
                },
                validation: {
                    required: false,
                    numeric: true,
                    minlength: 0,
                    maxLength: 4
                }
            }
            ,
            redBags: {
                label: '# Red @ $4.50',
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: '0'
                },
                validation: {
                    required: false,
                    numeric: true,
                    minlength: 0,
                    maxLength: 4
                }
            }
        }
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let val = event.target.value;
        if (val === undefined || val === '') {
            val = '0';
        }

        let valid = checkValidity(val, this.state.orderForm[inputIdentifier].validation);

        this.props.onDataChanged(inputIdentifier + '_touched', true);
        this.props.onDataChanged(inputIdentifier, val);
        this.props.onDataChanged(inputIdentifier + '_valid', valid);

        if (valid) {
            this.props.onDataChanged(inputIdentifier + '_valid', true);
            if (this.props.blackBags === 0) {
                this.props.onDataChanged('blackBags_valid', true);
                this.props.onDataChanged('blackBags_touched', true);
            }
            if (this.props.hardwoodBags === 0) {
                this.props.onDataChanged('hardwoodBags_valid', true);
                this.props.onDataChanged('hardwoodBags_touched', true);
            }
            if (this.props.cedarBags === 0) {
                this.props.onDataChanged('cedarBags_valid', true);
                this.props.onDataChanged('cedarBags_touched', true);
            }
            if (this.props.redBags === 0) {
                this.props.onDataChanged('redBags_valid', true);
                this.props.onDataChanged('redBags_touched', true);
            }
        }

    }

    formatNumber(value) {
        if (!value || value == '') {
            return '0.00';
        }
        else {
            return parseFloat(value).toFixed(2);
        }
    }


    render() {
        const formElementsArray = [];
        for (let key in this.state.orderForm) {
            let addIt = true;
            let label = this.state.orderForm[key].label;

            if (key == "hardwoodBags") {
                if (this.props.mulchYear.sellHardwood) {
                    label = '# Hardwood @ $' + this.formatNumber(this.props.mulchYear.hardwoodPrice);
                }
                else {
                    addIt = false;
                }
            }
            else if (key == "cedarBags") {
                if (this.props.mulchYear.sellCedar) {
                    label = '# Cedar @ $' + this.formatNumber(this.props.mulchYear.cedarPrice);
                }
                else {
                    addIt = false;
                }
            }
            else if (key == "blackBags") {
                if (this.props.mulchYear.sellBlack) {
                    label = '# Black @ $' + this.formatNumber(this.props.mulchYear.blackPrice);
                }
                else {
                    addIt = false;
                }
            }
            else if (key == "redBags") {
                if (this.props.mulchYear.sellRed) {
                    label = '# Red @ $' + this.formatNumber(this.props.mulchYear.redPrice);
                }
                else {
                    addIt = false;
                }
            }
            if (addIt) {
            formElementsArray.push({
                id: key,
                config: this.state.orderForm[key],
                label: label
            });
        }
        };

        
            let form = (
                <form onSubmit={this.orderHandler}>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            label={formElement.config.label}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={this.props[formElement.id]}
                            invalid={!this.props[formElement.id + '_valid']}
                            shouldValidate={formElement.config.validation}
                            touched={this.props[formElement.id + '_touched']}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                    ))}
                </form>
            );

            return (
                <div className={classes.MulchTypes}>
                    <h4>Quantities</h4>
                    {form}
                </div>
            );
        }
    };

    const mapStateToProps = state => {
        return {
            mulchYear: state.orders.mulchYear,
            hardwoodBags: state.orders.order.hardwoodBags,
            hardwoodBags_valid: state.orders.order.hardwoodBags_valid,
            hardwoodBags_touched: state.orders.order.hardwoodBags_touched,
            cedarBags: state.orders.order.cedarBags,
            cedarBags_valid: state.orders.order.cedarBags_valid,
            cedarBags_touched: state.orders.order.cedarBags_touched,
            blackBags: state.orders.order.blackBags,
            blackBags_valid: state.orders.order.blackBags_valid,
            blackBags_touched: state.orders.order.blackBags_touched,
            redBags: state.orders.order.redBags,
            redBags_valid: state.orders.order.redBags_valid,
            redBags_touched: state.orders.order.redBags_touched,
            isAuthenticated: state.orders.token !== null
        };
    }

    export default connect(mapStateToProps)(MulchTypes);


// WEBPACK FOOTER //
// ./src/components/Order/MulchTypes/MulchTypes.js